export default __webpack_public_path__ + "static/media/python.026a6268.svg";